export async function downloadGeneratedResult(result, onDownload, toast, fallbackMessage) {
  if (result?.id && typeof onDownload === "function") {
    await onDownload(result.id, { resolution: "hi" });
    return;
  }
  if (typeof toast === "function") toast(fallbackMessage);
}
